import Vue from "vue";
import VueRouter from "vue-router";
import Main from "@/views/Main/Main";
import Firebase from "@/views/Firebase/Firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    component: Main,
  },
  {
    path: "/firebase",
    name: "Firebase",
    component: Firebase,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
